export const TIERS = {
  BASE: 'base',
  PREMIUM: 'premium',
};

export const TIER_DEFAULT = 'premium';
